"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SanctionListsItem = void 0;
const Field_type_1 = require("../../../types/Field.type");
const SanctionsLists_1 = require("../../enm/SanctionsLists");
exports.SanctionListsItem = {
    priority: 1,
    label: 'fields.enm.sanctions_lists.label',
    fallbackLabel: 'Could you please confirm that, as a minimum requirement, regardless of the country of incorporation or applicable sanction regime, you utilize these sanctions lists for name and transaction sanction screening (select all that apply):',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['contract_onboarding_type'],
    type: Field_type_1.FieldType.Enum,
    options: SanctionsLists_1.SanctionsListsRef.options,
    trackFieldValueWithAnalytics: false,
};
function isMandatory(payload, path) {
    return (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
function isApplicable(payload, path) {
    return (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
